"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconExpand = function SvgIconExpand(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 48 48",
    "aria-label": "expand icon",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Expand Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.925 30.603l.094.082 1.296 1.296a.917.917 0 01.082 1.203l-.082.094-9.056 9.055h6.574V46h-11c-.962 0-1.75-.74-1.827-1.683L2 44.167v-11h3.667v6.574l9.055-9.056a.917.917 0 011.203-.082zm16.056.082a.917.917 0 011.297 0l9.055 9.056v-6.574H46v11C46 45.179 45.18 46 44.167 46h-11v-3.667h6.574l-9.056-9.055a.917.917 0 010-1.297zM44.167 2c.962 0 1.75.74 1.827 1.683l.006.15v11h-3.667V8.26l-9.055 9.056a.917.917 0 01-1.203.082l-.094-.082-1.296-1.296a.917.917 0 01-.082-1.203l.082-.094 9.056-9.055h-6.574V2h11zM14.833 2v3.667H8.26l9.056 9.055a.917.917 0 01.082 1.203l-.082.094-1.296 1.296a.917.917 0 01-1.203.082l-.094-.082-9.055-9.056v6.574H2v-11c0-.962.74-1.75 1.683-1.827L3.833 2h11z",
    fillRule: "nonzero"
  }));
};

var _default = SvgIconExpand;
exports.default = _default;